const React = require("react");
const { useParams } = require("react-router-dom");
const { usePrintify } = require("../context/PrintifyContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;
const DropshippingSupplierProducts = () => { const { supplierId } = useParams(); const { t } = usePrintify(); return h(ProductCollectionPage, { supplierId, title: t("h_printify_supplier_products", "Supplier products"), description: t("h_printify_supplier_products_desc", "Designed products available in this Printify store.") }); };
module.exports = { DropshippingSupplierProducts };
